import { Link } from "react-router-dom";
import { categories, categoryArticles, categoryVideos } from "@/lib/content";

export default function CategoryQuickLinks() {
  return (
    <section aria-label="资讯分类快捷入口" className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {categories.map((category, index) => {
        const total = categoryArticles(category.id).length + categoryVideos(category.id).length;
        return (
          <Link
            key={category.id}
            to={`/category/${category.id}`}
            className="group relative flex flex-col justify-between overflow-hidden rounded-lg border border-background-200 bg-background-100/70 p-4 transition-colors hover:border-primary-300 hover:bg-background-50 md:p-5"
          >
            <span className="absolute -right-6 -top-6 flex h-20 w-20 items-center justify-center rounded-full bg-background-200/60 text-background-300 transition-colors group-hover:bg-primary-100/60 group-hover:text-primary-300">
              <i className={`${category.icon} text-3xl`} />
            </span>
            <div className="relative">
              <p className="font-label text-[10px] uppercase tracking-[0.24em] text-foreground-400">{category.en}</p>
              <h3 className="mt-1.5 font-heading text-lg font-bold text-foreground-950">{category.name}</h3>
              <p className="mt-2 line-clamp-2-custom text-xs leading-relaxed text-foreground-500">
                {category.slogan}
              </p>
            </div>
            <div className="relative mt-6 flex items-center justify-between">
              <span className="text-xs text-foreground-400">{total} 篇内容</span>
              <span className="flex h-7 w-7 items-center justify-center rounded-full border border-background-300 text-foreground-600 transition-colors group-hover:border-primary-400 group-hover:bg-primary-500 group-hover:text-background-50">
                <i className="ri-arrow-right-line text-xs" />
              </span>
            </div>
            <span className="absolute inset-x-0 bottom-0 h-[2px] scale-x-0 bg-primary-500 transition-transform duration-500 group-hover:scale-x-100" />
            <span className="absolute right-4 top-4 font-editorial text-xs text-background-400">
              0{index + 1}
            </span>
          </Link>
        );
      })}
    </section>
  );
}